export default __webpack_public_path__ + "static/media/ophthalmological.4d978d67.jpg";